// Validating the field notes

// Validating the actaul Field Notes. General field notes are not required to be validated since they are not required to be submitted and just text.
//
export const validateDraftFieldNotes = (fieldNotesActivities) => {
  const errors = [];

  // Going through each activity in the fieldNotesActivities array
  fieldNotesActivities.forEach((activity) => {
    // Creating an activity error object
    const activityError = {
      activityRowId: activity.rowId,
      errors: { time: "", notes: "" },
    };

    // Validating the time
    const militaryTimeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    // Time can be null for draft validation
    if (activity.time && !militaryTimeRegex.test(activity.time)) {
      activityError.errors.time = "Invalid time";
    }
    //
    if (activityError.errors.time) {
      errors.push(activityError);
    }
  });
  return errors;
};

// Validating the submitted field notes
export const validateSubmittedFieldNotes = (fieldNotesActivities) => {
  const errors = [];

  // Going through each activity in the fieldNotesActivities array
  fieldNotesActivities.forEach((activity) => {
    // Creating an activity error object
    const activityError = {
      activityRowId: activity.rowId,
      errors: { time: "", notes: "" },
    };

    // Validating the time
    const militaryTimeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    // Time can't be null for submitted validation
    if (!activity.time || activity.time.trim() === "") {
      // activityError.errors.time = "Time is required";
    } else if (!militaryTimeRegex.test(activity.time)) {
      activityError.errors.time = "Invalid time";
    }
    // Validating the notes
    // if (!activity.notes || activity.notes.trim() === "") {
    //   activityError.errors.notes = "Notes are required";
    // }
    // Pushing the activity error to the errors array if there are any errors
    if (activityError.errors.notes || activityError.errors.time) {
      errors.push(activityError);
    }
  });
  return errors;
};
